"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE = void 0;
/** Supported identity types */
var TYPE;
(function (TYPE) {
    TYPE["ETHEREUM_ADDRESS"] = "ethereumAddress";
    TYPE["ETHEREUM_SMART_CONTRACT"] = "ethereumSmartContract";
})(TYPE || (exports.TYPE = TYPE = {}));
//# sourceMappingURL=identity-types.js.map